<template>
  <div class="bh-tabs-radios" :class="{ fullWidth, withBg }">
    <v-btn
      v-for="inputValue in values"
      color="accent"
      class="increase bh-tabs-radios__tab rounded-pill"
      small
      elevation="0"
      :width="fullWidth && values.length ? `${100 / values.length}%` : 'auto'"
      :key="inputValue.value"
      :text="value !== inputValue.value"
      @click="updateValue(inputValue.value)"
    >
      {{ inputValue.name }}
      <v-badge
        class="mt-0 bh-tabs-radios__tab-badge"
        v-if="!!inputValue.badgeValue"
        :content="inputValue.badgeValue"
        :value="inputValue.badgeValue"
        :color="value === inputValue.value ? 'bhBlue1' : 'bhNewGray'"
        inline
      />
    </v-btn>
  </div>
</template>
<script>
export default {
  name: "BhTabsRadios",
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    values: {
      type: Array,
      default: () => []
    },
    defaultValue: {
      type: String,
      default: ""
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    withBg: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  methods: {
    updateValue(value) {
      this.$emit("input", value);
    }
  },
  mounted() {
    if (this.defaultValue && !this.value && this.values.length) {
      if (this.values.find(el => el.value === this.defaultValue)) {
        this.updateValue(this.defaultValue);
      }
    }
  }
};
</script>
<style lang="scss">
// cannot use scoped
.bh-tabs-radios {
  width: auto;
  min-height: 40px;
  overflow: hidden;
  display: inline-flex;
  flex-wrap: wrap;
  border: 1px solid $bh-blue--4;
  border-radius: 20px;
  padding: 4px;

  &.fullWidth {
    width: 100%;
  }

  &.withBg {
    background-color: $bh-white;
  }

  &__tab {
    font-size: 0.715rem !important;
    font-weight: 700 !important;

    @media (min-width: 768px) {
      font-size: 1rem !important;
    }

    &-badge .bhNewGray {
      color: $bh-black;
    }
  }
}
</style>
